import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchChannelList = createAsyncThunk("fetchChannelList", async ({ filters, page, limit }) => {
	const params = new URLSearchParams({
		page,
		limit,
		keyword: filters?.keyword || "",
	});

	const response = await axiosHttp.get(`channels?${params}`);
	return response.data.data;
});

const ChannelListSlice = createSlice({
	name: "ChannelListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchChannelList.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchChannelList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.tableData.currentPage;
			state.total = action.payload.tableData.total;
		});
		builder.addCase(fetchChannelList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ChannelListSlice.reducer;
